<template>
    <div>
        <h3>{{ label }}</h3>
        <div class="document">
            <div v-if="name" class="document-icon"><icon :file="icon" :size="48" folder="files-types" /></div>
            <div v-if="name" class="document-content">
                <div class="document-name">
                    <span class="name">
                        <span v-if="name">{{ name }}</span>
                        <span v-else>{{ url }}</span>
                    </span>
                </div>
            </div>
            <div class="document-actions">
                <div class="document-action" title="Télécharger le fichier">
                    <a :href="secure_url" target="_blank">
                        <icon file="download" :size="24" />
                    </a>
                </div>
            </div>
        </div>

        <div
            v-if="!active_study_is_published"
            class="upload-area"
            @drop.prevent="addFile"
            @dragover.prevent
            @click="show_upload_box()"
        >
            <icon file="upload" :size="32" />
            <span class="legend">
                Glisser un document ou
                <a>cliquer ici</a>
            </span>
            <form action class="upload" :class="{ green: uploaded }">
                <input type="file" ref="upload_box" @change="handle_file_upload()"
					:accept="fileInputAcceptAttribute" />
            </form>
            <div v-show="uploading" class="loading">
                <icon file="loader" :size="32" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
moment.locale("fr");

import study_utils from "@/libs/study_utils";

const acceptedMimeTypes = [
	'application/pdf',
	'application/vnd.ms-excel',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'application/vnd.ms-powerpoint',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	'image/png',
	'image/jpeg'
];
const acceptedExtensions = [
	'.pdf',
	'.xls',
	'.xlsx',
	'.ppt',
	'.pptx',
	'.png',
	'.jpeg',
	'.jpg',
	'.png'
];

export default {
	name: "static-study-file",
	data: function () {
		return {
			more_menu: false,
			show_switcher_info: false,
			uploading: false,
			uploaded: false,
			the_file: "",
			fileInputAcceptAttribute: [...acceptedMimeTypes, ...acceptedExtensions]
		};
	},
	props: {
		parent_data: { default: null },
		file_property: { default: "" },
		label: { default: "" },
	},
	computed: {
		...mapGetters(["active_study", "active_study_is_published", "user"]),
		url () {
			return this.parent_data[this.file_property]
		},
		secure_url () {
			return this.url+"?token="+this.user.token;
		},	
		name () {
			if (!this.url || !this.url.length) {
				return "";
			}
			return this.url.substring(this.url.lastIndexOf("/")+1);
		},
		type () {
			if (!this.name || !this.name.length) {
				return "";
			}
			const lastDot = this.name.lastIndexOf(".");
			return this.name.substring(lastDot + 1);
		},
		icon () {
			if (!this.name || !this.name.length) {
				return "";
			}
			return study_utils.ext_to_icon(this.type);
		},
	},
	filters: {
		moment: function (value) {
			return moment(value).format("ll");
		},
	},
	methods: {
		addFile (e) {
			const droppedFiles = e.dataTransfer.files;
			if (!droppedFiles) return;
			this.study_file = droppedFiles[0];
			this.upload_file();
		},
		show_upload_box: function () {
			this.$refs.upload_box.click();
		},
		handle_file_upload: function () {
			const input = this.$refs.upload_box;
			if (input.files && input.files[0]) {
				this.study_file = input.files[0];
				this.upload_file();
			}
		},
		async upload_file () {
			this.uploading = true;
			this.uploaded = false;
			try {
				await this.$store.dispatch("upload_file", {
					the_file: this.study_file,
					parent_data: this.parent_data,
					property: this.file_property,
				});
				this.$store.dispatch("save_study");
			} catch (error) {
				console.error("ERROR while uploading file to study", this.file_property, error);
			}
			this.uploading = false;
			this.uploaded = true;
		},
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/app'

h3
    margin 16px
.upload-area
    display flex
    flex-direction column
    align-items center
    justify-content center
    margin 24px
    height 120px
    border 2px dashed #ddd
    background-color #f5f5f5
    border-radius radius
    color #bbb
    font-weight 500
    cursor pointer

    &:hover
        border-color #ccc
        background-color #eee

    .legend
        margin 4px 0 0 0

        a
            text-decoration underline

            &:hover
                text-decoration none

    input
        position absolute
        top 0
        left 10000px
        opacity 0

    .dropbox
        height @width
        border 2px dashed light
        border-radius radius
        background-color alpha(light, 5%)
        cursor pointer

        &:hover
            background-color alpha(light, 10%)

    &.green
        background-color green
        color white

        > .tooltip
            color white

        > .dropbox
            color white
            border none

        &:hover
            background-color darken(green, 15%)

.loading
    animation rotate 1s linear infinite
    color #bbb

@keyframes rotate
    from
        transform rotate(0deg)

    to
        transform rotate(359deg)

	.document
		display block
		min-height (48px + 32px)
		padding 16px 24px
		border-radius radius
		line-height 24px
		white-space nowrap
		cursor default
		&:hover
			background-color #eee
			.document-actions
				opacity 1
		.document-icon
			float left
			transform translateY(1px)
			.icon
				display block
		.document-content
			display block
			margin-left 64px
			.document-name
				display block
				font-weight 500
				transform translateY(1px)
				.input
					display block
					width 180px
					border none
					font inherit
					background transparent
					&:focus
						background #fff
						box-shadow 0 0 0 2px #fff, 0 0 0 4px red
			.document-description
				display block
				transform translateY(-1px)
				color lighten(dark, 50%)
				font-size 12px
				span
					display inline-block
					margin 0 16px 0 0
					> .icon
						float left
						margin 4px 4px 0 0
				a
					text-decoration underline
					&:hover
						text-decoration none
		.document-actions
			opacity 0
			position absolute
			right 20px
			top 20px
			height 40px
			display flex
			align-items center
			justify-content center
			.document-action
				display inline-block
				width 40px
				height 40px
				padding 8px
				border-radius 100%
				cursor pointer
				color dark
				&:hover
					background-color dark
					color #fff
				.icon
					display block
</style>
